<script setup>
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useMessagesStore } from '@/stores/messages'

const authStore = useAuthStore()
const router = useRouter()
const route = useRoute()
const username = ref('')
const password = ref('')
const error = ref('')
const messages = useMessagesStore()

async function handleSubmit() {
  try {
    const success = await authStore.login(username.value, password.value)

    if (success) {
      messages.success('🔓 Právě jsi se přihlásil.')
      const redirectPath = route.query.redirect || '/'
      router.push(redirectPath)
    } else {
      error.value = 'Nesprávné přihlašovací údaje'
    }
  } catch (e) {
    // Něco se pokazilo při komunikaci se serverem
    error.value = 'Chyba při přihlašování: ' + (e.response?.data?.msg || e.message)
  } finally {
    // Vynulujeme heslo v každém případě
    password.value = ''
  }
}
</script>

<template>
  <main>
    <div class="login">
      <h2>Login</h2>
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <label>Uživatelské jméno:</label>
          <input
            id="username"
            type="text"
            v-model="username"
            placeholder="abc12345"
            required
          />
        </div>

        <div class="form-group">
          <label>Heslo:</label>
          <div>
            <input type="password" v-model="password" required />
          </div>
        </div>

        <button type="submit">Přihlásit</button>

        <p v-if="error" class="error">{{ error }}</p>
      </form>
    </div>
  </main>
</template>

<style scoped>
.login {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.form-group div {
  text-align: center;
}

input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}


button {
  width: 100%;
  padding: 0.5rem;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.error {
  color: red;
  margin-top: 1rem;
}
</style>
